
(function () {
    angular.module('tmx-app').directive("tmxEcib", tmxEcib);

    function tmxEcib() {
        return {
            scope: {

                required: "@",
                disabled: "=",
                label:"=",
                value:'=',
                OnClick:"&",
                companyBranchCode:'=',
                emailAddress:'=',
                firstName:'=',
                middleName:'=',
                lastName:'=',
                gender:'=',
                cnic:'=',
                phone:'=',
                address:'=',
                requestedLoanAmount:'=',
                businessNature:'=',
                city:'=',
                dateOfBirth:'='
            },
            restrict: 'E',
            templateUrl: 'common/directives/tmxecib/tmxecib.html',
            controller: ["$scope","$mdDialog","$state",tmxEcibCtrl],
            controllerAs: 'EcibCtrl'
        };

    }

    function tmxEcibCtrl($scope,$mdDialog,$state) {

        var EcibCtrl=this;
        EcibCtrl.scope=$scope;
        EcibCtrl.SomeFunc=function(){
            $mdDialog.show({
                locals:{VerificationValue: $scope.value, companyBranchCode: $scope.companyBranchCode, emailAddress: $scope.emailAddress, firstName: $scope.firstName, middleName: $scope.middleName, lastName: $scope.lastName, gender: $scope.gender, cnic: $scope.cnic, phone: $scope.phone, address: $scope.address, requestedLoanAmount: $scope.requestedLoanAmount, businessNature: $scope.businessNature, city: $scope.city,dateOfBirth:$scope.dateOfBirth},
                controller: ["$scope", "$mdDialog", "$state","$http","$sce","VerificationValue","companyBranchCode","emailAddress","firstName","middleName","lastName","gender","cnic","phone","address","requestedLoanAmount","businessNature","city","dateOfBirth","APP_CONSTANTS",DialogController],
                controllerAs: 'dialogCtrl',
                templateUrl:"common/directives/tmxecib/tmxecibdialog.html",
                parent: angular.element(document.body),
                clickOutsideToClose:true
            })
                .then(function(dataItem){
                    EcibCtrl.scope.value=dataItem;
                });
        }
    }
    function DialogController($scope,$mdDialog,$state,$http,$sce,VerificationValue, companyBranchCode, emailAddress, firstName, middleName, lastName, gender, cnic, phone, address, requestedLoanAmount, businessNature, city,dateOfBirth,APP_CONSTANTS){
        var data={
            "CompanyBranchCode":companyBranchCode,
            "SubBranchCode" :"",
            "EmailAddress":emailAddress,
            "AccountType":"",
            "AssociationType":"",
            "CheckerUserName":"",
            "CheckerPassword":"",
    /*        "EmployerAddress":"19 AIBAK BLOCK NEW GARDEN TOWN",
            "EmployerPhoneNo":"35847812",
            "EmployerCellNo":"03154021911",
            "EmployerCityOrDistrict":"LAHORE",
            "EmployerCompanyName":"kashf foundation",
            "EmployerEmailAddress":"abc@mail.com",
            "EmployerOwnershipStatus":"PROPRIETORSHIP",*/
            "FatherOrHusbandFirstName":"",
            "FatherOrHusbandMiddleName":"",
            "FatherOrHusbandLastName":"",
            "FirstName":firstName,
            "MiddleName":middleName,
            "LastName":lastName,
            "Gender":gender,
            "GroupId":"",
            "MakerUserName":"",
            "MakerPassword":"",
            "MemberCode":"",
            "NicNoOrPassportNo":cnic,
            "PhoneNo":phone,
            "Address":address,
            "RequestedLoanAmount":requestedLoanAmount,
            "BusinessNature":businessNature,
            "City":city,
            "DateOfBirth":dateOfBirth
        }
        var dialogCtrl=this;

        dialogCtrl.vm={};
        dialogCtrl.vm=data;
        dialogCtrl.loading=false;
        dialogCtrl.FieldShow=true;
        dialogCtrl.FrameShow=false;
        dialogCtrl.ShowErrors=false;
        dialogCtrl.frameUrl="";
        dialogCtrl.Errors="";
        if(angular.isDefined(data.Gender)){
            if(data.Gender=="1082"){
                data.Gender="Male";
            }
            else{
                data.Gender="Female";
            }
        }
/*
        dialogCtrl.form;
*/
        dialogCtrl.cancel=function(){
            $mdDialog.cancel();
        }

        dialogCtrl.Submit=function(){
            dialogCtrl.loading=true;

            dialogCtrl.Errors="";

            $http.post(APP_CONSTANTS.backend+"Enquiry/GetBureauCreditReport",dialogCtrl.vm)
                .then(function(response){
                    if(angular.isDefined(response)){
                        switch(response.data.status.code) {
                        case 200:
                            if(response.data.statue.message=="MFCIB report fetched successfully."){
                                dialogCtrl.FieldShow=false;
                                dialogCtrl.frameUrl=$sce.trustAsResourceUrl(response.data.data);
                                dialogCtrl.loading=false;
                                dialogCtrl.FrameShow=true;
                                break;

                            }
                            else{
                                dialogCtrl.loading=false;
                                dialogCtrl.ShowErrors=true;
                                angular.forEach(response.data.data,function (item) {

                                    if(dialogCtrl.Errors!=""){
                                        dialogCtrl.Errors+=","+item;
                                    }
                                    else{
                                        dialogCtrl.Errors=item;
                                    }
                                });

                                break;
                            }


                        case 400:
                            dialogCtrl.loading=false;
                            dialogCtrl.ShowErrors=true;
                            break;


                        }


                    }
                });
        }
        dialogCtrl.Verify=function(){
            VerificationValue=true;
            $mdDialog.hide(VerificationValue);
        }
    }

})();